import { apiClient } from "@api/client";
import { request } from "@api/request";
import { ClinicAuthError } from "@auth/clinicAuthClient";

/** Mirrors brian's `BrowserEndpointOut`/`BrowserRegistrationOut` (modules/phone/schemas.py). */
interface BrowserEndpoint {
  id: string;
  label: string;
  sipAddress: string;
}

interface BrowserRegistration {
  endpointId: string;
  sipAddress: string;
  /** Never stored. */
  token: string;
}

/** Idempotent per (user, installation). 409 `browser_calling_unavailable`: no browser credential connection here. */
export const pairBrowserEndpoint = (
  installationId: string,
): Promise<BrowserEndpoint> =>
  request(() =>
    apiClient.POST("/phone/browser-endpoint", {
      body: { installation_id: installationId },
    }),
  ).then((e) => ({
    id: e.endpoint_uuid,
    label: e.label,
    sipAddress: e.sip_address,
  }));

/** Also bumps brian's `last_registered_at`. 404 `browser_endpoint_not_paired` before {@link pairBrowserEndpoint}. */
export const fetchBrowserRegistration = (
  installationId: string,
): Promise<BrowserRegistration> =>
  request(() =>
    apiClient.POST("/phone/browser-endpoint/token", {
      body: { installation_id: installationId },
    }),
  ).then((r) => ({
    endpointId: r.endpoint_uuid,
    sipAddress: r.sip_address,
    token: r.token,
  }));

export const describeSoftphoneError = (error: unknown): string => {
  if (error instanceof ClinicAuthError) {
    if (error.status === 409)
      return "Browser calling isn't turned on in this environment.";
    if (error.status === 429)
      return "Too many headset connections just now. Try again in a minute.";
    if (error.code === "network_error")
      return "Brian couldn't be reached to connect the headset.";
  }
  return "Brian couldn't connect the headset.";
};
